{
  "welcome_subtitle": "Meus projetos ao vivo",
  "welcome_title": "Bem-vindo, {{ name }}",
  "view_project": "Visualizar projeto",
  "my_projects": "Meus projetos",
  "create_project_form": {
    "title": "Novo projeto",
    "title_edit": "Editar projeto",
    "project_name": "Nome do projeto",
    "project_expiry_date": "Data de expiração do projeto",
    "project_apps": "Aplicativos e recursos",
    "billing_provider": "Provedor de cobrança",
    "subscription_plan": "Plano de assinatura",
    "subscription_plan_price": "Preço",
    "billing_invalid": "Selecione um método de cobrança",
    "plan_invalid": "Selecione um plano",
    "price_invalid": "Selecione um preço",
    "name_invalid": "Por favor, insira um nome.",
    "date_invalid": "Insira uma data válida depois de hoje.",
    "max_users": "Máximo de usuários",
    "max_users_invalid": "O máximo de usuários deve ser maior que 0",
    "unlimited_users": "Usuários ilimitados",
    "unlimited": "Ilimitado"
  },
  "billing_popover": {
    "renew_button": "Renove a assinatura agora",
    "body": "Sua assinatura expirou. Para recuperar o acesso ao seu projeto, renove hoje mesmo."
  },
  "service_unavailable": {
    "body": "Este projeto expirou. Entre em contato com o administrador do projeto para renovar a assinatura.",
    "support": "Para obter mais assistência, por favor"
  }
}